import type { FC } from 'react';

import { Link, type LinkProps } from '@remix-run/react';

import { COMMUNITY_ROUTES } from '~/constants/community';

import { FROM_INSIDE_APP_STATE } from '../_utils/fromInsideApp';

type PostLinkProps = Omit<LinkProps, 'to' | 'state'> & {
  postId: string;
  hash?: string;
};

// Carry `state.fromInsideApp = true` so the post page's back button can pop history
export const PostLink: FC<PostLinkProps> = ({ postId, hash, children, ...rest }) => {
  const to = hash ? `${COMMUNITY_ROUTES.post(postId)}#${hash}` : COMMUNITY_ROUTES.post(postId);

  return (
    <Link to={to} state={FROM_INSIDE_APP_STATE} {...rest}>
      {children}
    </Link>
  );
};
